/*** IMPORTS FROM imports-loader ***/
var global = window;

// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}

